import { differenceInYears, isValid, parse } from "date-fns"

export const calculateAgeFromBirthDate = (
  birthDate: string,
  referenceDate: Date = new Date()
): number | null => {
  const parsedBirthDate = parse(birthDate, "yyMMdd", new Date())

  if (!isValid(parsedBirthDate)) {
    return null
  }

  if (parsedBirthDate > new Date()) {
    parsedBirthDate.setFullYear(parsedBirthDate.getFullYear() - 100)
  }

  return differenceInYears(referenceDate, parsedBirthDate)
}
